(function ($) {
    'use strict';
    $(document).ready(function () {
        var element = $(".sylius-table-column-code");
        var tr = element.closest("tr");
        var th = tr.find('th');

        if ($(th).closest('table').find('.sylius-table-column-product').length) {
          return;
        }

        var index = $(th).index(element);
        if (element.length) {
            element.hide();
            element.closest('table').find('tr > td:nth-child(' + (index + 1) + ')').hide();
        }
    });
})(jQuery);
